"use client"

import { Session } from "next-auth"
import { useState } from "react"

import LoginDetailsPopupContent from "../Navbar/LoginDetailsPopupContent"
import HeaderPopover from "./HeaderPopover"

export default function Wrapper({
  displayName,
  session,
  updateMyInformationLink,
  email,
  phone
}: {
  displayName?: string
  session?: Session | null
  updateMyInformationLink?: string
  email?: string
  phone?: string
}) {
  const [open, setOpen] = useState(false)
  return (
    <HeaderPopover displayName={displayName} open={open} setOpen={setOpen}>
      <LoginDetailsPopupContent
        displayName={displayName}
        session={session}
        updateMyInformationLink={updateMyInformationLink}
        email={email}
        phone={phone}
        setOpen={setOpen}
      />
    </HeaderPopover>
  )
}
